import { createRef, useEffect, useState } from 'react';
import { HTTP, HTTPS, getUrlAndProtocol } from 'EmailComponents/utils/urlUtils';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import UISelect from 'UIComponents/input/UISelect';
import UITextInput from 'UIComponents/input/UITextInput';
import { InputGroup } from 'foundations-components/transitional/components/InputGroup';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UrlFieldWithProtocol = ({
  onUrlChange = () => {},
  showError = false,
  validationMessage,
  value,
  inputGroupProps,
  onBlur = () => {}
}) => {
  const [protocol, setProtocol] = useState(HTTPS);
  const [cleanUrl, setCleanUrl] = useState('');
  const _inputRef = /*#__PURE__*/createRef();
  const onProtocolChange = newProtocol => {
    if (!newProtocol) return;
    setProtocol(newProtocol);
    onUrlChange(`${newProtocol}${cleanUrl}`);
  };
  const onUrlTextChange = url => {
    const {
      url: strippedUrl,
      protocol: updatedProtocol = protocol
    } = getUrlAndProtocol(url);
    setCleanUrl(strippedUrl);
    setProtocol(updatedProtocol);
    const newUrlWithProtocol = `${updatedProtocol}${strippedUrl}`;
    onUrlChange(newUrlWithProtocol);
  };
  useEffect(() => {
    const {
      url,
      protocol: updatedProtocol
    } = getUrlAndProtocol(value);
    setProtocol(updatedProtocol || HTTP);
    setCleanUrl(url);
  }, [value]);
  useEffect(() => {
    if (_inputRef.current) _inputRef.current.focus();
  }, [_inputRef]);
  return /*#__PURE__*/_jsxs(InputGroup, Object.assign({
    "data-test-id": "url-field-with-protocol",
    label: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "EmailComponentsCrossFrame.rssUrl.label"
    }),
    use: "itemLeft",
    required: true,
    error: showError,
    validationMessage: validationMessage
  }, inputGroupProps, {
    children: [/*#__PURE__*/_jsx(FormControl, {
      children: /*#__PURE__*/_jsx(UISelect, {
        "data-test-id": "url-field-protocol",
        options: [{
          value: HTTPS,
          text: HTTPS
        }, {
          value: HTTP,
          text: HTTP
        }],
        defaultValue: protocol,
        clearable: false,
        value: protocol,
        onChange: ({
          target
        }) => void onProtocolChange(target.value)
      })
    }), /*#__PURE__*/_jsx(FormControl, {
      children: /*#__PURE__*/_jsx(UITextInput, {
        "data-test-id": "url-field-value",
        name: "rss_url",
        value: cleanUrl,
        onChange: ({
          target
        }) => void onUrlTextChange(target.value),
        inputRef: _inputRef,
        onBlur: onBlur
      })
    })]
  }));
};
export default UrlFieldWithProtocol;